import React, { useEffect } from 'react';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Box } from '@/components/lib/components';
import { setDepositAmount } from '@/feature/deposit/hooks/use-deposit-status-store';
import { KycStackScreenProps } from '@/navigation/kyc/types';
import { logger } from '@/utils/logging';

type ScreenProps = KycStackScreenProps<'TrustlyId'>;

export const TrustlyId = ({ navigation }: ScreenProps) => {
    useEffect(() => {
        setDepositAmount('0');
        try {
            navigation.navigate('TrustlyWebview', { isTrustlyIdOnly: true });
        } catch (error) {
            logger.error('Unable to navigate to TrustlyWebview from TrustlyId', error);
        }
    }, [navigation]);

    return (
        <Box flex={1} justifyContent={'center'} alignItems={'center'} bg="neutral900">
            <LoadingSpinner />
        </Box>
    );
};
